import { Token } from '~core/modules/identity/models/identity.model';

export class DigitalAccountError implements Error {
  public readonly name = 'DigitalAccountError';
  public readonly message = 'This digital account is not registered in MM system!';

  constructor(public readonly token: Token) {}
}
